/* eslint-disable eqeqeq */
import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { cleverTap, postFileData, s3FileUpload, uploadFile } from "../../../services/provider/common";
import { SingleConfirmAppointments } from "../../../services/provider/appointment";
import Alert from '@mui/material/Alert';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import RefreshIcon from '@mui/icons-material/Refresh';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import { AppID, BRANCH_WHITELISTED_PROVIDERS, CLEVER_TAP_EVENTS, QCSTATE_PROVIDERS, STATUS_CODE_MAP, USER } from '../../../constants/provider/constant';
import { useLocation } from 'react-router';
import { toast } from "react-toast";
import { MBContract } from '../../../constants/insurance/constant';
import { requestHistory } from '../../../services/provider/requestHistory';
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import DescriptionTwoToneIcon from '@material-ui/icons/DescriptionTwoTone';

export default function SubmitDocumentsDialog(props) {

    const location = useLocation()
    const [details] = React.useState(props.details);
    const [status] = React.useState(props?.status ? props.status : 'pending');
    const [notes, setNotes] = React.useState('');
    const [labReports, setLabReports] = React.useState([]);
    const [bills, setBills] = React.useState([]);
    const [reportGuid, setReportGuid] = React.useState({});
    const [billGuid, setBillGuid] = React.useState({});
    const [prevFiles, setPrevFiles] = React.useState({});
    const [prevRep, setPrevRep] = React.useState({});
    const [prevBills, setPrevBills] = React.useState({});

    useEffect(()=>{
        cleverTap(CLEVER_TAP_EVENTS.attachDocsPopupShown, {
            statusInfo: "Customer awaited at DC",
            requestID : details['requestId'],
            costType : details['additionalInformation'].isPaid?"Paid":"Unpaid",
            visitType : details['additionalInformation'].visitType,
            testCategory : details['additionalInformation'].productName
        })
        if([STATUS_CODE_MAP["Information Awaited"],STATUS_CODE_MAP["Partial Report Uploaded"]].includes(details.currentStatusId)){
            requestHistory(details['requestId'])
            .then((res)=>{
                if(res && res.isSuccess === true){
                    let fileHist = res.requestHistory.statusHistory.find(ele=>ele.statusId === 162)
                    if(fileHist && fileHist.attachedFiles!=={})
                        setPrevFiles(fileHist.attachedFiles)
                }
            })
            .catch(err=>console.error(err));
        }
    },[details])

    const handleFieldChange = async(event) => {
        event.preventDefault();
        const { name, value, files } = event.target;
        let res ={};
        if(files)
            for (let i=0;i<Object.keys(files).length;i++ ) {
                let fileDetails = {
                    // file: files[i],
                    type: files[i]?.type,
                    fileName: files[i]?.name,
                    signedUrl: "",
                    fileIdentifier: "",
                    fileType: "Report",
                    appId: AppID,
                    EntityRelationId:  USER?.user?.entityId,
                    s3AccountType:  "MB",
                    "contractType": details?.requestContractType
                }
                let dat= await uploadFile(fileDetails);
                
                if(dat?.success) {
                    let fileArr = new FormData();
                    fileArr.append("Content-Disposition", "\"form-data\"");
                    fileArr.append("name", "\"file\"");
                    fileArr.append("FileCategory", "\"Report\"");
                    fileArr.append("userName", "\"Plus\"");
                    fileArr.append("FileType", "\"Report\"");
                    fileArr.append("providerId", USER.user.providerId);
                    fileArr.append("file",files[i.toString()])
                    fileDetails.file = files[i];
                    fileDetails.signedUrl = dat.signedURL;
                    fileDetails.fileIdentifier = dat.fileIdentifier;
                    fileDetails.fileName = dat.fileName;
                    const myNewFile = new File([fileDetails.file], dat?.fileName, {type: fileDetails.file.type});
                    fileDetails.file = myNewFile;
                    let s3Data = await s3FileUpload(files[i], dat?.signedURL);
                    if(s3Data?.status === 200 || s3Data === 200) {
                        delete fileDetails.file
                        let data = await postFileData(fileDetails);
                        console.log(data);
                        let dat = {};
                        dat[data?.fileIdentifier] = data?.fileName;
                        res={
                            ...res,
                            ...dat
                        }
                    }
                }
                if(!dat || dat ==={})
                cleverTap(name ==="bills"?CLEVER_TAP_EVENTS.uploadBillsFailed:CLEVER_TAP_EVENTS.uploadReportFailed, {
                    srcPage: location.pathname,
                    statusInfo: "Customer awaited at DC",
                    requestID : details.requestId,
                    costType : details.additionalInformation.isPaid?"Paid":"Unpaid",
                    visitType : details.additionalInformation.visitType,
                    testCategory : details.additionalInformation.productName,
                    isUploadSuccess: 0
                })
            }
        let reports = [];
        if(event.target.files){
         reports = Array.from(files)
        }
        switchCase(name, value, reports,res);
    } 

    console.log("details", details)

    const getNextStatusId = (details) => {
        if(MBContract["PreEmployment"] === details.requestContractType && QCSTATE_PROVIDERS.includes(USER?.user?.providerId)) {
            return STATUS_CODE_MAP["Branch Approval Pending"];
        }
       else if(
            [MBContract["ESALES"], MBContract["PrePolicy"]].includes(details.requestContractType ) && 
            ! BRANCH_WHITELISTED_PROVIDERS.includes( USER.user.providerId ) &&
            ! ['cat12','cat 12', 'Cat 2', 'Cat2', 'cat2', 'cat 2'].includes(details.additionalInformation.productName.toLowerCase())
        ){
            return STATUS_CODE_MAP["Branch Approval Pending"]            
        }
        else{
            return  STATUS_CODE_MAP["Info submitted"]
        }
    }

    const submitDetails = async (submitNow) => {
        cleverTap(CLEVER_TAP_EVENTS.attachDocsFinalClick, {
            srcPage: location.pathname,
            statusInfo: "Customer awaited at DC",
            requestID : details.requestId,
            costType : details.additionalInformation.isPaid?"Paid":"Unpaid",
            visitType : details.additionalInformation.visitType,
            testCategory : details.additionalInformation.productName
        })
        const payload ={
            requestAccessToken:JSON.parse(localStorage.getItem("access_token")),
            request:{
                requestId:details.requestId,
                currentStatusId:details.currentStatusId,
                requestedNextActionId: submitNow ? getNextStatusId(details) : STATUS_CODE_MAP["Partial Report Uploaded"] ,
                ScheduledAppointmentDate:details.additionalInformation.appointmentDate,
                remarks:notes,
                attachFiles:{
                    reports:{
                        ...reportGuid,
                        ...prevRep
                    },
                    bills:{
                        ...billGuid,
                        ...prevBills
                    }
                }
                
            }
        }
        SingleConfirmAppointments(payload)
        .then((res)=>{
            if(res.isSuccess){
                toast.success("Reports uploaded for request")
            }
            else{
                toast.error(`Reports were not uploaded ${res?.errorMessage ?? ""}`)
            }
            props.closeDialogAndRefresh("REFRESH");
        })
        .catch(err=>{console.log(err);toast.error("Reports not uploaded for request")});
    }

    const closePopUp = () => {
        props.closeDialog();
    }


    const switchCase = (name, value, files, guid) => {
        console.log("files",files['FileList'])
        switch (name) {
            case 'notes':
                setNotes(value);
                break;
            case 'lab-reports' : 
                setLabReports(labReports.concat(files))
                setReportGuid({
                    ...reportGuid,
                    ...guid
                })
                break;
            case 'bills' : 
                setBills(bills.concat(files))
                setBillGuid({
                    ...billGuid,
                    ...guid
                })
                // setBills(files);
                // setBillGuid(guid);
                break;
            default:
                break;
        }
    }

    const checKUpload= (type, name) =>{
        let guidObj= type==="report"?reportGuid:billGuid;
        for (let key in guidObj) {
           if(name===guidObj[key])
               return true
        }
        return false
    }

    const reUploadSingleFile = async (fileDetails, data) => {
        const dat = await uploadFile(fileDetails);
        if(dat?.success) {
            fileDetails.file = data;
            fileDetails.signedUrl = dat.signedURL;
            fileDetails.fileIdentifier = dat.fileIdentifier;
            fileDetails.fileName = dat.fileName;
            const myNewFile = new File([fileDetails.file], dat?.fileName, {type: fileDetails.file.type});
            fileDetails.file = myNewFile;
            let fileArr = new FormData();
            fileArr.append("Content-Disposition", "\"form-data\"");
            fileArr.append("name", "\"file\"");
            fileArr.append("FileCategory", "\"Report\"");
            fileArr.append("userName", "\"Plus\"");
            fileArr.append("FileType", "\"Report\"");
            fileArr.append("providerId", USER.user.providerId);
            fileArr.append("file",data)
            let s3Data = await s3FileUpload(data, dat?.signedURL);
            if(s3Data?.status === 200 || s3Data === 200) {
                delete fileDetails.file
                let response = await postFileData(fileDetails);
                console.log(response);
                let dat = {};
                dat[response?.fileIdentifier] = response?.fileName;
                return dat;
            }
        }
    }

    const reUpload = async(type, data) => {
        let fileDetails = {
            // file: files[i],
            type: data?.type,
            fileName: data?.name,
            signedUrl: "",
            fileIdentifier: "",
            fileType: "Report",
            appId: AppID,
            EntityRelationId:  USER?.user?.entityId,
            s3AccountType:  "MB",
            "contractType": details?.requestContractType
        }
        let res={
            ...(type === "report" ? reportGuid: billGuid),
            ...(await reUploadSingleFile(fileDetails, data))
        } 
        if(type ==="report") setReportGuid(res);
        else setBillGuid(res)
    }

    const remove = (type, data,index,bool) => {
        let guidObj = type==="report" ? reportGuid : billGuid;
        if(bool)
        for (const key in guidObj) {
            if(guidObj[key] === data.name){
                delete guidObj[key];
            }
        }

        let obj = type==="report"? Array.from(labReports) : Array.from(bills);
        obj.splice(index,1);
        (type === "report") ? setLabReports(obj) : setBills(obj)

    }

    const clickedUpload=(e)=>{
        if(e.target.id === "lab-reports")
        cleverTap(CLEVER_TAP_EVENTS.attachReportsClick, {
            srcPage: location.pathname,
            statusInfo: "Customer awaited at DC",
            requestID : details.requestId,
            costType : details.additionalInformation.isPaid?"Paid":"Unpaid",
            visitType : details.additionalInformation.visitType,
            testCategory : details.additionalInformation.productName
        })
        else
        cleverTap(CLEVER_TAP_EVENTS.attachBillsClick, {
            srcPage: location.pathname,
            statusInfo: "Customer awaited at DC",
            requestID : details.requestId,
            costType : details.additionalInformation.isPaid?"Paid":"Unpaid",
            visitType : details.additionalInformation.visitType,
            testCategory : details.additionalInformation.productName
        })
    }

    const reuseOldFiles = (data, type) => {
        debugger;
        let files;
        let setter;
        if(type==="Report"){
            files = prevRep;
            setter = setPrevRep;
        }
        else{
            files = prevBills;
            setter = setPrevBills;
        }
        let obj = {};
        Object.assign(obj,files)
        if(files[Object.keys(data)[0]]){
            delete obj[Object.keys(data)[0]]
        }else{
            obj = {
                ...files,
                ...data
            }
        }
        setter(obj);
    }

    return (
        <div className="mt-5">
            <Box
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={(event) => submitDetails(event)}
            >
                <div className="pb-5">
                    <Alert severity="error">
                        <strong>  Please upload {status === 'pending'?"reports": "bills"  } appropriately to avoid delay in processing as well as repeated requests for more information. </strong>
                    </Alert>
                    <div>
                        <span className="text-sm text-gray-600">

                        </span>
                    </div>
                </div>

                {prevFiles &&
                <div className="flex justify-around">
                    <div className="w-49-per">
                            <div className="px-5 text-center">
                                <div className="z-20 ">
                                    {
                                        prevFiles && Object.keys(prevFiles?.reports ?? {}).length>0 &&
                                        Object.keys(prevFiles.reports).map((elem,ind) => {
                                            return(
                                            <div key={ind} className="relative flex justify-between w-full rounded bg-sky-300">
                                                    <FormControlLabel
                                                        checked={ prevRep[elem] ? true : false }
                                                    control={
                                                        <Checkbox
                                                        onChange={()=>reuseOldFiles({[elem]:prevFiles.reports[elem]}, "Report")}
                                                        />
                                                    }
                                                    label={
                                                <div className="justify-start w-full px-1">
                                                    <span className="text-gray-600"><DescriptionTwoToneIcon style={{fontSize: '18px'}} /></span>
                                                    <span className="text-xs text-gray-700">{prevFiles.reports[elem]}</span>
                                                </div>

                                                    }
                                                    />
                                            </div>
                                        )})
                                    }
                                </div>
                            </div>
                    </div>
                    <div className="w-49-per">
                            <div className="px-5 text-center">
                                <div className="z-20 ">
                                    {
                                        prevFiles && Object.keys(prevFiles?.bills ?? {}).length >0 &&
                                        Object.keys(prevFiles.bills).map((elem,ind) => {
                                            return(
                                            <div key={ind} className="relative flex justify-between w-full rounded bg-sky-300">
                                                    <FormControlLabel
                                                        checked={ prevBills[elem] ? true : false }
                                                    control={
                                                        <Checkbox
                                                        onChange={()=>reuseOldFiles({[elem]:prevFiles.bills[elem]}, "Bills")}
                                                        />
                                                    }
                                                    label={
                                                <div className="justify-start w-full px-1">
                                                    <span className="text-gray-600"><DescriptionTwoToneIcon style={{fontSize: '18px'}} /></span>
                                                    <span className="text-xs text-gray-700">{prevFiles.bills[elem]}</span>
                                                </div>

                                                    }
                                                    />
                                            </div>
                                        )})
                                    }
                                </div>
                            </div>
                    </div>
                </div>
                }
                <div className="flex justify-around py-5">
                    <div className="w-49-per">
                            <div className="p-5 text-center border-2 border-gray-400 border-dotted rounded m-aut0">
                        <label htmlFor="lab-reports">
                                <div>
                                    <FileUploadIcon></FileUploadIcon>
                                </div>
                                <div className="text-xs font-semibold text-gray-500 cursor-pointer">
                                    Attach Lab Reports
                                </div>
                        </label>
                            </div>
                            <div className="p-5 text-center rounded m-aut0">
                                <div className="z-20 pt-5">
                                    {
                                        ['pending','partialReceived'].includes(status) && labReports && labReports.length > 0 ? labReports.map((elem,ind) => {
                                            let bool =checKUpload("report",elem.name)
                                            return(
                                            <div key={ind} className={bool?"bg-green-100 rounded py-1 my-1 flex relative justify-between w-full":"bg-red-100 rounded py-1 my-1 flex relative justify-between w-full"}>
                                                <div className="w-3/4 px-2 text-left">
                                                    <span className="text-gray-600"><UploadFileIcon style={{fontSize: '18px'}}></UploadFileIcon></span>
                                                    <span className="text-xs text-gray-700">{elem.name}</span>
                                                </div>
                                                <div className="flex w-1/4">
                                                <div>
                                                    {
                                                        bool?<CheckIcon className="font-bold text-green-700" style={{fontSize:'15px'}} ></CheckIcon>:<RefreshIcon className="text-gray-500 cursor-pointer" onClick={()=>reUpload("report",elem)}></RefreshIcon>
                                                    }
                                                </div>
                                                <div><CancelIcon onClick={()=>remove("report", elem,ind,bool)} className="mx-2 text-red-600 cursor-pointer" style={{fontSize: '15px'}}></CancelIcon></div>
                                            </div>
                                            </div>
                                        )}) : <></>
                                    }
                                    {
                                        prevRep !== {} && Object.keys(prevRep).map((elem,ind) => {
                                            return(
                                            <div key={ind} className="relative flex justify-between w-full py-1 my-1 bg-green-100 rounded">
                                                <div className="w-3/4 px-2 text-left">
                                                    <span className="text-gray-600"><UploadFileIcon style={{fontSize: '18px'}}></UploadFileIcon></span>
                                                    <span className="text-xs text-gray-700">{prevRep[elem]}</span>
                                                </div>
                                                <div className="flex w-1/4">
                                                <div>
                                                    <CheckIcon className="font-bold text-green-700" style={{fontSize:'15px'}} ></CheckIcon>
                                                </div>
                                            </div>
                                            </div>
                                        )})
                                    }
                                </div>
                                </div>
                        <input type="file" id="lab-reports"
                         className="hidden" multiple name="lab-reports"
                         onClick={(e)=>{clickedUpload(e)}}
                          onChange={(event) => handleFieldChange(event)} />
                    </div>
                    <div className="w-49-per">
                            <div className="p-5 text-center border-2 border-gray-400 border-dotted rounded m-aut0">
                        <label htmlFor="bills">
                                <div>
                                    <FileUploadIcon></FileUploadIcon>
                                </div>
                                <div className="text-xs font-semibold text-gray-500 cursor-pointer">
                                    Attach Bills
                                </div>
                        </label>
                            </div>
                            <div className="p-5 text-center rounded m-aut0">
                                <div className="pt-5">
                                {
                                         bills && bills.length > 0 ? bills.map((elem,ind) => {
                                            let bool =checKUpload("bills",elem.name)
                                            return(
                                                <div key={ind} className={bool?"bg-green-100 rounded py-1 my-1 flex relative justify-between w-full":"bg-red-100 rounded py-1 my-1 flex relative justify-between w-full"}>
                                                    <div className="w-3/4 px-2 text-left">
                                                        <span className="text-gray-600"><UploadFileIcon style={{fontSize: '18px'}}></UploadFileIcon></span>
                                                        <span className="text-xs text-gray-700">{elem.name}</span>
                                                    </div>
                                                    <div className="flex w-1/4">
                                                        <div>
                                                            {
                                                                bool?<CheckIcon className="font-bold text-green-700" style={{fontSize:'15px'}} ></CheckIcon>:<RefreshIcon className="text-gray-500 cursor-pointer" onClick={()=>reUpload("bills",elem)}></RefreshIcon>
                                                            }
                                                        </div>
                                                        <div><CancelIcon onClick={()=>remove("bills", elem,ind,bool)} className="mx-2 text-red-600 cursor-pointer" style={{fontSize: '15px'}}></CancelIcon></div>
                                                    </div>
                                                </div>
                                        )}) : <></>
                                    }
                                    {
                                        prevBills !== {} && Object.keys(prevBills).map((elem,ind) => {
                                            return(
                                            <div key={ind} className="relative flex justify-between w-full py-1 my-1 bg-green-100 rounded">
                                                <div className="w-3/4 px-2 text-left">
                                                    <span className="text-gray-600"><UploadFileIcon style={{fontSize: '18px'}}></UploadFileIcon></span>
                                                    <span className="text-xs text-gray-700">{prevBills[elem]}</span>
                                                </div>
                                                <div className="flex w-1/4">
                                                <div>
                                                    <CheckIcon className="font-bold text-green-700" style={{fontSize:'15px'}} ></CheckIcon>
                                                </div>
                                            </div>
                                            </div>
                                        )})
                                    }
                                </div>
                                </div>
                        <input type="file" id="bills" className="hidden" multiple name="bills" onChange={(event) => handleFieldChange(event)} />
                    </div>

  </div>

                <div className="pb-10">
                    <FormControl className="w-full">
                        <TextField
                            sx={{ '& .MuiOutlinedInput-input, .MuiInputLabel-root': { fontSize: 14 } }}
                            id="outlined-multiline-static"
                            label="Remarks*"
                            multiline
                            name="notes"
                            onChange={(event) => handleFieldChange(event)}
                            rows={4}
                            value={notes}
                        />
                    </FormControl>
                </div>

                <div className='flex justify-between pb-5 text-center'>
                    <div className="w-40 p-1 text-sm font-semibold text-gray-900 border border-gray-600 rounded-md cursor-pointer" type="submit" variant="contained" size="large" onClick={closePopUp}>
                        <span>
                            Cancel
                        </span>
                    </div>
                    {
                         [MBContract["ESALES"],MBContract["PrePolicy"]].includes(details.requestContractType) && details.currentStatusId != STATUS_CODE_MAP["Partial Report Uploaded"] &&
                        <div className={`border text-gray-100 rounded-md w-40 p-1 text-sm ${Object.keys(reportGuid).length !== 0 && notes ?"cursor-pointer border-green-600 bg-green-600": " bg-green-300 border-green-300" }  font-semibold`}  type="submit" variant="contained" size="large" onClick={Object.keys(reportGuid).length !== 0 && notes ? ()=> submitDetails(false) : undefined}>
                            <span>
                                Partial Upload
                            </span>
                        </div>
                    }
                    <div className={`border text-gray-100 rounded-md w-40 p-1 text-sm ${Object.keys(reportGuid).length + Object.keys(prevRep).length !== 0 && notes ?"cursor-pointer border-green-600 bg-green-600": " bg-green-300 border-green-300" }  font-semibold`}  type="submit" variant="contained" size="large" onClick={Object.keys(reportGuid).length + Object.keys(prevRep).length !== 0 && notes ? ()=>submitDetails(true) : undefined}>
                        <span>
                            Submit
                        </span>
                    </div>

                </div>
            </Box>
        </div>
    );
}